export enum UserStatus {
  New = 0,
  PendingCommercial = 1,
  CommercialDone = 2,
  AdminTeam = 3,
  ManagerTeam = 4,
  ViewerTeam = 5,
  AdminStrm = 6,
  TeamDisabled = 7,
}
